import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MsgBrokerService {

  private viewerSelectedSource = new Subject<string>();
  
  viewerSelected$ = this.viewerSelectedSource.asObservable();
  

  constructor() { }

  selectViewer(viewer) {
    this.viewerSelectedSource.next(viewer);
  }
}
